import getArticleField from './news/getArticleField';

const getConnectionField = (prefix, hasLocalNews) => `${
  getArticleField(prefix, hasLocalNews)}sConnection`;

export default getConnectionField;
